import { useAppSelector } from 'app/hooks';
import { getSelectedWeek, getSelectedYear } from 'app/slices/GamesSlice';
import { getBESyncSeasons } from 'app/slices/SyncManagerSlice';
import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { AppRoutes } from 'routes/Routes';

/**
 * Expands the weekly schedule index using the application's selected season and week.
 * Authentication is handled before this route is mounted.
 *
 * @return {null} No content while replacing the index URL with its selected week.
 */
export const WeeklyGamesIndexRoute: React.FC = () => {
  const navigate = useNavigate();
  const { search, hash } = useLocation();
  const selectedWeek = useAppSelector(getSelectedWeek);
  const selectedYear = useAppSelector(getSelectedYear);
  const seasons = useAppSelector(getBESyncSeasons);
  const availableYears = seasons.map(({ seasonID }) => seasonID);
  const year =
    availableYears.length && !availableYears.includes(selectedYear) ? [...availableYears].sort().at(-1) : selectedYear;
  useEffect(() => {
    if (year && selectedWeek) {
      navigate(`${AppRoutes.WeeklyGames}/${year}/${selectedWeek.toLowerCase()}${search}${hash}`, {
        replace: true,
        // Remember an automatic season choice so it can be checked when metadata arrives.
        state: { validateSelectedSeason: !availableYears.length },
      });
    }
  }, [year, selectedWeek, search, hash, availableYears.length, navigate]);
  return null;
};
export default WeeklyGamesIndexRoute;
